import ActionModal from '@insurancemenu/imenu-components-lib/dist/components/modals/ActionModal';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { EmployeeActionUiPresenter } from 'store/modules/add-employees/employeeDelegate';
import ModalDelegate from 'store/general/modalDelegate';
import { GeneralEmployeeAction } from 'store/modules/add-employees/types';
import { ModalType } from '@insurancemenu/imenu-components-lib/dist/helpers/ModalsHelper';
import { WARNING_MODALS_TEST_IDS } from '../constants';

function renderModal(action: EmployeeActionUiPresenter, warningModals: Record<string, ModalDelegate>): React.ReactNode {
  const warningModal = warningModals[action.type];
  if (!warningModal) {
    return null;
  }

  if (action.type === String(GeneralEmployeeAction.REMOVE_EMPLOYEE)) {
    return (
      <ActionModal
        key={action.type}
        title="Remove employee"
        subtitle="Are you sure you want to remove this employee?"
        show={warningModal.isVisible}
        onClose={warningModal.close}
        closeButtonText="No"
        actionButtonText="Yes"
        onAction={async () => {
          warningModal.close();
          await action.handler();
        }}
        modalType={ModalType.DELETE}
        data-test-id={WARNING_MODALS_TEST_IDS.REMOVE_EMPLOYEE_MODAL}
      />
    );
  }
  return null;
}

interface Props {
  availableActions: EmployeeActionUiPresenter[];
  warningModals: Record<string, ModalDelegate>;
}

const WarningModals: React.FC<Props> = observer(({ availableActions, warningModals }) => {
  return <>{availableActions.map((actionObj) => renderModal(actionObj, warningModals))}</>;
});

export default WarningModals;
